import { AiOutlineQuestionCircle } from 'react-icons/ai';

import * as S from './style';

interface PageHelpTriggerProps {
  onClick: () => void;
  ariaLabel?: string;
}

const PageHelpTrigger = ({
  onClick,
  ariaLabel = '이 페이지 사용 가이드',
}: PageHelpTriggerProps) => {
  return (
    <S.TriggerButton
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <AiOutlineQuestionCircle size={20} />
    </S.TriggerButton>
  );
};

export default PageHelpTrigger;
